import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./style.styl";
import { ChevronLeft, ChevronRight } from "@gravity-ui/icons";
import { Button, Card, Icon } from "@gravity-ui/uikit";
export var ImageSlider = function (props) { return (_jsx(Card, { type: "container", view: "outlined", style: { overflow: "hidden" }, children: _jsxs(Swiper, { effect: "slide", navigation: {
            nextEl: ".swiper-custom__next",
            prevEl: ".swiper-custom__prev",
        }, pagination: {
            clickable: true,
        }, modules: [Navigation, Pagination], className: "mySwiper", loop: props.images.length > 1, children: [props.images.map(function (image, index) { return (_jsx(SwiperSlide, { children: _jsx("img", { src: image }) }, index)); }), _jsxs("div", { className: "swiper-custom", children: [_jsx(Button, { className: " swiper-custom__prev", view: "flat", pin: "circle-circle", size: "xl", children: _jsx(Icon, { data: ChevronLeft, size: 32 }) }), _jsx(Button, { className: "swiper-custom__next", view: "flat", pin: "circle-circle", size: "xl", children: _jsx(Icon, { data: ChevronRight, size: 32 }) })] })] }) })); };
